export default __webpack_public_path__ + "static/media/Glodani 10.7d346a78.jpg";